var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message)?_c('div',{staticClass:"alert alert-danger"},[_c('h4',[_vm._v(_vm._s(_vm.$t('rest.errors.title')))]),_vm._v("\n\t"+_vm._s(_vm.message)+"\n")]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b79e55c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/InfoError.vue
// module id = null
// module chunks = 